const nameTranslationMap = new Map()
nameTranslationMap.set("Cecil (Dark Knight)", "cecil")
nameTranslationMap.set("Cecil (Paladin)", "cecilpaladin")
nameTranslationMap.set("Raines", "cidraines")

export function getCompendiumUrl(characterName: string) {
  const safeCharaName = nameTranslationMap.get(characterName) || (characterName.replace(/[^\w\s]/g, "").replace(/\s/g, "").toLowerCase())
  return `https://dissidiacompendium.com/characters/${safeCharaName}`
}
